import React from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label } from 'cw-ui-core';
import Locale from 'src/i18n';
import TextButton from '../../../../components/TextButton';

export const CANCEL_PRODUCT_DIALOG = 'CANCEL_PRODUCT_DIALOG';

const CancelProductDialog = props => {
    const { formatMessage } = props.intl;

    const dialogButtons = [
        <TextButton key="ok" automationName="ok" text={formatMessage(Locale.ok)} onClick={props.onOk} />,
        <TextButton
            key="cancel"
            automationName="cancel"
            text={formatMessage(Locale.cancel)}
            onClick={props.onCancel}
        />,
    ];

    return (
        <Dialog
            dialogId={CANCEL_PRODUCT_DIALOG}
            header={formatMessage(Locale.cancelProductHeader)}
            buttons={dialogButtons}>
            <br />
            <div>
                <ScreenMessagePanelContainer screenKey={CANCEL_PRODUCT_DIALOG} />
                <Label>{formatMessage(Locale.cancelProductConfirm)}</Label>
            </div>
        </Dialog>
    );
};

export default injectIntl(CancelProductDialog);
